import { useNavigate } from "react-router-dom";
import { useDialog } from "@shared/features/dialog/useDialog";
import { useIsSupportPage } from "../../hooks/useIsSupportPage";
import { useSupportSheet } from "../../hooks/useSupportSheet";
import { useSupport } from "../../SupportContext";
import { Props as SupportProps, Support } from "./Support";
import { Article } from "../../support.types";

export type Props = Omit<
  SupportProps,
  "onSearchClick" | "onSupportClick" | "articles" | "categories" | "isLoading"
> & {
  articleId?: string;
};

export function SupportContainer({
  children,
  articleId,
  title,
  description,
  ...props
}: Props) {
  const navigate = useNavigate();

  const { articles, categories, isLoading } = useSupport();

  const { setSheetArticleId } = useSupportSheet();

  const { openDialog } = useDialog();

  const isSupportPage = useIsSupportPage();

  const handleSearchClick = () => {
    openDialog("supportSearch");
  };

  const handleSupportClick = () => {
    openDialog("supportTicket");
  };

  const handleNavigationClick = (article: Article) => {
    isSupportPage
      ? navigate(`/support/${article.id}`)
      : setSheetArticleId(article.id);
  };

  const article = articles.find((article) => article.id === articleId);

  const computedTitle = article?.title ?? title;

  const computedDescription = article ? null : description;

  return (
    <Support
      title={computedTitle}
      description={computedDescription}
      articles={articles}
      categories={categories}
      isLoading={isLoading}
      onNavigationClick={handleNavigationClick}
      onSearchClick={handleSearchClick}
      onSupportClick={handleSupportClick}
      {...props}
    >
      {children}
    </Support>
  );
}

export default SupportContainer;
